import { callApi } from 'helpers/saga-helpers';
import {
  setAllFeeNotes,
  setFeeNotesSearch,
} from 'containers/LawyerFeeNote/actions';
import { takeLeading, put } from 'redux-saga/effects';
import {
  PROCEDURE_STEPS,
  REQUEST_OPENING_MANAGER_FEE_NOTES,
  REQUEST_MANAGER_FEE_NOTES,
  REQUEST_FEE_NOTES_BY_CLAIM_NUMBER,
  MAKE_DECISION_FEE_NOTE,
  REQUEST_ALL_FEE_NOTES,
  REQUEST_FEE_NOTE_EXCEPTIONAL_COSTS,
  REQUEST_MANAGER_FEE_NOTES_BY_POLICY_NUMBER,
  REQUEST_MANAGER_ALL_FEE_NOTES,
  REQUEST_CREATE_FEE_NOTE_MANAGER,
  REQUEST_ADD_FEE_NOTE_EXCEPTIONAL_COSTS_SAGIS,
  REQUEST_MANAGER_FEE_NOTES_BY_REGISTRATION_NUMBER,
} from 'containers/LawyerFeeNote/constants';
import userToken from 'containers/services/security/access-token-storage';
import { get, isEmpty, isNull } from 'lodash';
import { makeDecisionFeeNoteAction } from 'containers/ManagerFeeNote/typings';
import { createFeeNoteAction } from 'containers/LawyerFeeNote/typings';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { requestSagisClaimInfo } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export function* requestManagerFeeNotes(action: {
  status: string;
  transactionAreaId: any;
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { page, pageSize, status } = action;
  const token = get(userToken.get(), 'token');
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  if (isNull(token)) return;
  const path = !isEmpty(get(action, 'transactionInboxeAreaId', []))
    ? `/corporeal/fee-note/manager?status=${status}&page=${page}&pageSize=${pageSize}&isOpeningManager=${isOpeningManager}&transactionInboxeAreaId=[${get(
        action,
        'transactionInboxeAreaId',
        null,
      )}]`
    : `/corporeal/fee-note/manager?status=${status}&page=${page}&pageSize=${pageSize}&isOpeningManager=${isOpeningManager}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesSearch);
}

export function* requestManagerFeeNotesSaga() {
  yield takeLeading(REQUEST_MANAGER_FEE_NOTES, requestManagerFeeNotes);
}
export function* requestManagerAllFeeNotes(action: {
  status: string;
  type: string;
}): Generator<unknown> {
  const { status } = action;
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const path = `/corporeal/fee-note/manager?status=${status}&isOpeningManager=${isOpeningManager}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(
    path,
    {},
    options,
    [],
    setFeeNotesSearch,
    undefined,
    false,
    LOADERS.FEE_NOTE,
  );
}

export function* requestManagerAllFeeNotesSaga() {
  yield takeLeading(REQUEST_MANAGER_ALL_FEE_NOTES, requestManagerAllFeeNotes);
}
export function* requestAllFeeNotes(action: {
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { page, pageSize } = action;
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const path = `/corporeal/fee-note/manager?page=${page}&pageSize=${pageSize}&isOpeningManager=${isOpeningManager}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setAllFeeNotes);
}
export function* requestAllFeeNotesSaga() {
  yield takeLeading(REQUEST_ALL_FEE_NOTES, requestAllFeeNotes);
}

export function* requestFeeNotesBySinistre(action: {
  page: number;
  pageSize: number;
  claimNumber: string;
  type: string;
  transactionAreaId?: any;
  viewByClaim?: boolean;
  claimId?: string;
}): Generator<unknown> {
  const { claimNumber, viewByClaim, claimId } = action;
  const token = get(userToken.get(), 'token');
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  if (isNull(token)) return;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let path;
  if (claimNumber) {
    path = !isEmpty(get(action, 'transactionAreaId', []))
      ? `/corporeal/fee-note/GetByClaimNum/manager/${claimNumber}?isOpeningManager=${isOpeningManager}&transactionInboxeAreaId=[${get(
          action,
          'transactionAreaId',
          null,
        )}]`
      : featureService.hasFeature(FEATURES.EVOLUTION_P3) && viewByClaim
      ? `/corporeal/fee-note/GetByClaimNum/manager/${claimNumber}`
      : `/corporeal/fee-note/GetByClaimNum/manager/${claimNumber}?isOpeningManager=${isOpeningManager}`;

    yield callApi(path, {}, options, [], setFeeNotesSearch, (data: any) => {
      return { data: { ...data } };
    });
  } else if (claimId) {
    path = `/corporeal/fee-note/GetByClaimId/manager/${claimId}?isOpeningManager=${isOpeningManager}`;
    yield callApi(path, {}, options, [], setFeeNotesSearch);
  } else {
  }
}
export function* requestFeeNotesBySinistreSaga() {
  yield takeLeading(
    REQUEST_FEE_NOTES_BY_CLAIM_NUMBER,
    requestFeeNotesBySinistre,
  );
}
export function* requestOpeningManagerFeeNotes(action: {
  status: string;
  page: number;
  pageSize: number;
  type: string;
}): Generator<unknown> {
  const { page, pageSize, status } = action;
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const path = `/corporeal/fee-note/manager?status=${status}&step=${PROCEDURE_STEPS.PV}&page=${page}&pageSize=${pageSize}&isOpeningManager=${isOpeningManager}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesSearch);
}

export function* requestOpeningManagerFeeNotesSaga() {
  yield takeLeading(
    REQUEST_OPENING_MANAGER_FEE_NOTES,
    requestOpeningManagerFeeNotes,
  );
}

export function* makeDecisionFeeNote(
  action: makeDecisionFeeNoteAction,
): Generator<unknown> {
  const { decision, successCallBack } = action;
  const token = get(userToken.get(), 'token');
  const path = `/corporeal/fee-note/validate-fee-note`;
  const options = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...decision,
    }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    if (decision.viewByClaim) {
      yield put(
        requestSagisClaimInfo(get(decision, 'claimNumber', null), () => {}),
      );
    }
  }
}

export function* makeDecisionFeeNoteSaga() {
  yield takeLeading(MAKE_DECISION_FEE_NOTE, makeDecisionFeeNote);
}

export function* requestFeeNoteExceptionalCosts(
  action: createFeeNoteAction,
): Generator<unknown> {
  const { feeNote, successCallBack } = action;
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const path = `/corporeal/fee-note/add-fee-costs`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...feeNote,
    }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestFeeNoteExceptionalCostsToSagis(
  action: any,
): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const path = `/corporeal/add-fee-note-manager`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestFeeNoteExceptionalCostsSaga() {
  yield takeLeading(
    REQUEST_FEE_NOTE_EXCEPTIONAL_COSTS,
    requestFeeNoteExceptionalCosts,
  );
}
export function* requestFeeNoteExceptionalCostsToSagisSaga() {
  yield takeLeading(
    REQUEST_ADD_FEE_NOTE_EXCEPTIONAL_COSTS_SAGIS,
    requestFeeNoteExceptionalCostsToSagis,
  );
}
export function* requestFeeNotesByPolicyNumber(action: {
  page: number;
  pageSize: number;
  policyNumber: string;
  type: string;
  transactionAreaId?: any;
}): Generator<unknown> {
  const { policyNumber } = action;
  const token = get(userToken.get(), 'token');
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  if (isNull(token)) return;
  const path = !isEmpty(get(action, 'transactionAreaId', []))
    ? `/corporeal/fee-note/GetByPolicyNumber/manager/${policyNumber}?isOpeningManager=${isOpeningManager}&transactionInboxeAreaId=[${get(
        action,
        'transactionAreaId',
        null,
      )}]`
    : `/corporeal/fee-note/GetByPolicyNumber/manager/${policyNumber}?isOpeningManager=${isOpeningManager}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesSearch, (data: any) => {
    /* istanbul ignore next */
    return { data: { ...data } };
  });
}
export function* requestFeeNotesByPolicyNumberSaga() {
  yield takeLeading(
    REQUEST_MANAGER_FEE_NOTES_BY_POLICY_NUMBER,
    requestFeeNotesByPolicyNumber,
  );
}
export function* requestCreateFeeNoteManager(action: any): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = get(userToken.get(), 'token');
  if (isNull(token)) return;
  const path = `/corporeal/add-fee-note-go`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestCreateFeeNoteManagerSaga() {
  yield takeLeading(
    REQUEST_CREATE_FEE_NOTE_MANAGER,
    requestCreateFeeNoteManager,
  );
}

export function* requestFeeNotesByRegistrationNumber(action: {
  page: number;
  pageSize: number;
  registrationNumber: string;
  type: string;
  transactionAreaId?: any;
}): Generator<unknown> {
  const { registrationNumber } = action;
  const token = get(userToken.get(), 'token');
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  if (isNull(token)) return;
  const path = !isEmpty(get(action, 'transactionAreaId', []))
    ? `/corporeal/fee-note/GetByRegistrationNumber/manager/${registrationNumber}?isOpeningManager=${isOpeningManager}&transactionInboxeAreaId=[${get(
        action,
        'transactionAreaId',
        null,
      )}]`
    : `/corporeal/fee-note/GetByRegistrationNumber/manager/${registrationNumber}?isOpeningManager=${isOpeningManager}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, {}, options, [], setFeeNotesSearch, (data: any) => {
    return { data: { ...data } };
  });
}
export function* requestFeeNotesByRegistrationNumberSaga() {
  yield takeLeading(
    REQUEST_MANAGER_FEE_NOTES_BY_REGISTRATION_NUMBER,
    requestFeeNotesByRegistrationNumber,
  );
}
export default [
  requestManagerFeeNotesSaga,
  requestOpeningManagerFeeNotesSaga,
  requestFeeNotesBySinistreSaga,
  makeDecisionFeeNoteSaga,
  requestAllFeeNotesSaga,
  requestFeeNoteExceptionalCostsSaga,
  requestFeeNoteExceptionalCostsToSagisSaga,
  requestFeeNotesByPolicyNumberSaga,
  requestManagerAllFeeNotesSaga,
  requestFeeNotesByRegistrationNumberSaga,
  requestCreateFeeNoteManagerSaga,
];
